<template>
  <div>
    <header>
      <div class="header-img">
        <img
          :src="userInfo.HeadImageUrl !=null?userInfo.HeadImageUrl +'?x-oss-process=image/resize,m_fill,h_72,w_72':defaultImg"
          :onerror="defaultImg"
          alt
        >
      </div>
      <div class="name">{{userInfo.RealName?userInfo.RealName:userInfo.NickName}}</div>
    </header>
    <ul class="menu-list">
      <li>
        <router-link :to="{name:'my-activity'}">
          <i></i>
          <span>我报名的活动</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name:'my-collect'}">
          <i></i>
          <span>我的收藏</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name:'my-info'}">
          <i></i>
          <span>我的资料</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{name:'my-qrcode'}">
          <i></i>
          <span>我的二维码</span>
        </router-link>
      </li>
    </ul>
    <button class="btn-main btn-quit" @click="onExit">退出登录</button>
    <footer-logo></footer-logo>
    <footer-nav :name="name"></footer-nav>
  </div>
</template>

<script>
import footerNav from '@/views/footerNav.vue'
import footerLogo from '@/components/footerLogo.vue'
export default {
  components: {
    'footer-nav': footerNav,
    'footer-logo': footerLogo
  },
  created() {
    this.getUserInfo()
  },
  data() {
    return {
      name: {
        name: '我的'
      },
      userInfo: {},
      userData: {},
      defaultImg: 'this.src="' + require('@/assets/images/defaultImg.png') + '"'
    }
  },
  methods: {
    getUserInfo() {
      this.$fetch('/api/MemberShip/Info', this.userData).then(result => {
        this.userInfo = result
      })
    },
    onExit() {
      window.localStorage.removeItem('ei_token')
      this.$dialog.toast({
        mes: '退出成功',
        timeout: 500
      })
      setTimeout(() => {
        this.$router.push({
          path: '/'
        })
      }, 500)
    }
  }
}
</script>

<style lang="less" scoped>
header {
  width: 100%;
  height: 340 / @rem-size;
  background: url('../assets/images/mine-bc.png');
  background-size: 100% 100%;
  padding-top: 50 / @rem-size;

  .header-img {
    width: 145 / @rem-size;
    height: 145 / @rem-size;
    border-radius: 50%;
    margin: 0 auto;
    border: 6 / @rem-size solid #ffffff;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .name {
    font-size: 36 / @rem-size;
    color: #fff;
    text-align: center;
    margin-top: 20 / @rem-size;
  }
}

.menu-list {
  background: #fff;

  li {
    width: 100%;
    height: 108 / @rem-size;
    position: relative;

    &:active {
      background: #fff - 10%;
    }

    i {
      display: block;
      width: 64 / @rem-size;
      height: 64 / @rem-size;
      background-image: url('../assets/images/menu-icon.png');
      background-size: 264 / @rem-size 64 / @rem-size;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 24 / @rem-size;
      margin: auto;
    }

    &::after {
      display: block;
      content: '';
      width: 25 / @rem-size;
      height: 32 / @rem-size;
      background-image: url('../assets/images/right-icon.png');
      background-size: 100% 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 24 / @rem-size;
      margin: auto;
    }

    &:nth-child(2) {
      i {
        background-position: -66 / @rem-size 0;
      }
    }

    &:nth-child(3) {
      i {
        background-position: -132 / @rem-size 0;
      }
    }

    &:nth-child(4) {
      i {
        background-position: -198 / @rem-size 0;
      }
    }

    &:last-child {
      span::after {
        width: 0 !important;
      }
    }

    span {
      display: block;
      font-size: 28 / @rem-size;
      color: #333;
      padding-left: 114 / @rem-size;
      line-height: 108 / @rem-size;
      position: relative;

      &::after {
        display: block;
        content: '';
        width: 636 / @rem-size;
        height: 1px;
        background: #e5e5e5;
        margin: auto;
        position: absolute;
        bottom: 0;
        right: 0;
        margin: auto;
      }
    }
  }
}

.btn-quit {
  display: block;
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  margin: 0 auto;
  margin-top: 40 / @rem-size;
  font-size: 36 / @rem-size;
  color: #fff;
  border-radius: 8 / @rem-size;
}
</style>
